const fetch = require("isomorphic-fetch");
const Dropbox = require("dropbox").Dropbox;
const dbx = new Dropbox({
  fetch: fetch,
  accessToken:
    "b-TxMhg7wmcAAAAAABiOl_5JiyeefA0elglApZxmxg3Uc9n7uXMt65Um5ajpJjuC",
});

async function getDropboxFileRequest(path, title) {
  await dbx
    .filesCreateFolderV2({
      path: path,
      autorename: false,
    })
    .catch((error) => {
      if (error.error.error_summary.includes("path/conflict/folder")) {
      } else console.error(JSON.stringify(error));
    });
  let existingRequestURL;
  const existingRequests = await dbx.fileRequestsListV2().catch((error) => {
    return { error: true, errorText: "Could not connect to Dropbox..." };
  });
  existingRequests.result.file_requests.forEach((req) => {
    if (req.is_open) {
      if (req.title === title) {
        existingRequestURL = req.url;
      }
    }
  });
  if (existingRequestURL) return existingRequestURL;
  const res = await dbx
    .fileRequestsCreate({
      title: title,
      destination: path,
      open: true,
    })
    .catch(function (error) {
      console.error(JSON.stringify(error));
      return { error: true, errorText: error.error.error_summary };
    });
  return res.result.url;
}

async function getDropboxLink(path, setShowUploadScreen = () => { }, createFolder = true) {
  const existingLinkRes = await dbx
    .sharingListSharedLinks({
      path: path,
      direct_only: true,
    })
    .catch((error) => {
      console.error(`Error listing shared links for path "${path}":`, JSON.stringify(error));
      return {
        error: true,
        errorText: error.error.error_summary || error,
        result: { links: [] },
      };
    });
  if (!existingLinkRes) {
    return { error: true, errorText: "Could not connect to Dropbox..." };
  }

  if (existingLinkRes.error) {
    if (existingLinkRes.errorText.includes("path/not_found")) {
      if (!createFolder) {
        return { error: true, errorText: "Path not found" };
      }

      const createFolderRes = await dbx
        .filesCreateFolderV2({
          path: path,
          autorename: false,
        })
        .catch((error) => {
          console.error(`Error creating folder for path "${path}":`, JSON.stringify(error));
          return { error: true, errorText: error.error.error_summary };
        });
      if (createFolderRes.error) {
        return createFolderRes;
      }
    } else return existingLinkRes;
  }

  if (existingLinkRes.result.links.length === 0) {
    const createLinkRes = await dbx
      .sharingCreateSharedLinkWithSettings({
        path: path,
        settings: {
          requested_visibility: "public",
          audience: "public",
          access: "viewer",
        },
      })
      .catch((error) => {
        console.error(`Error creating shared link for path "${path}":`, JSON.stringify(error));
        return { error: true, errorText: error.error.error_summary };
      });
    return createLinkRes.result.url;
  } else {
    return existingLinkRes.result.links[0].url;
  }
}
const getDropboxUrlWithRetry = async (basePath, maxRetries = 14) => {
  const dropboxUrlRegex =
    /^https:\/\/(www\.dropbox\.com|dl\.dropboxusercontent\.com)\/.+/i;

  let attempts = 0;
  let storyboardsUrl = null;

  while (attempts < maxRetries) {
    try {
      storyboardsUrl = await getDropboxLink(basePath, noop);

      if (dropboxUrlRegex.test(storyboardsUrl)) {
        return storyboardsUrl;
      }

      console.warn(
        `Invalid Dropbox URL on attempt ${attempts + 1}, retrying...`
      );
      attempts++;

      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error(`Error on attempt ${attempts + 1}:`, error);
      attempts++;

      if (attempts < maxRetries) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }
  }

  console.error(`Failed to get valid Dropbox URL after ${maxRetries} attempts`);
  return false;
};

const listFolderContents = async (path = "") => {

  try {
    let allEntries = [];
    let currentCursor = null;
    let pageCount = 0;

    do {
      pageCount++;
      let response;

      if (currentCursor) {
        response = await withRateLimitRetry(
          () => dbx.filesListFolderContinue({ cursor: currentCursor }),
          "listFolderContents"
        );
      } else {
        response = await withRateLimitRetry(
          () =>
            dbx.filesListFolder({
              path,
              recursive: true,
              include_media_info: true,
              limit: 2000, // Increased limit to reduce API calls
            }),
          "listFolderContents"
        );
      }

      const result = response.result;

      allEntries = [...allEntries, ...result.entries];

      currentCursor = result.has_more ? result.cursor : null;

    } while (currentCursor); // Continue while there are more pages

    const filesOnly = allEntries.filter(entry => entry && entry[".tag"] === "file");


    if (filesOnly.length > 0) {
    }

    return { entries: filesOnly, has_more: false };
  } catch (error) {
    console.error(`❌ listFolderContents: Error listing folder "${path}":`, error);
    throw error;
  }
};

const listSubfolders = async (path = "") => {

  try {
    let allEntries = [];
    let currentCursor = null;

    do {
      let response;

      if (currentCursor) {
        response = await withRateLimitRetry(
          () => dbx.filesListFolderContinue({ cursor: currentCursor }),
          "listSubfolders"
        );
      } else {
        response = await withRateLimitRetry(
          () =>
            dbx.filesListFolder({
              path,
              recursive: false, // Only list direct children, not recursive
              include_media_info: false,
            }),
          "listSubfolders"
        );
      }

      const result = response.result;
      allEntries = [...allEntries, ...result.entries];
      currentCursor = result.has_more ? result.cursor : null;

    } while (currentCursor);

    // Filter only folders
    const foldersOnly = allEntries.filter(entry => entry && entry[".tag"] === "folder");

    return { entries: foldersOnly, has_more: false };
  } catch (error) {
    console.error(`❌ listSubfolders: Error listing subfolders for "${path}":`, error);
    throw error;
  }
};

const getThumbnails = async (files, options = {}, onProgress = null) => {
  if (!files || files.length === 0) return {};

  const {
    batchSize = 15,
    delayBetweenBatches = 700,
    maxRetries = 8,
    size = "w960h640",
    // size = "w1024h768",
    // size = "w2048h1536",
    mode = "strict",
    onBatch = null,
  } = options;

  const allThumbnails = {};

  const validFiles = files.filter((file) => isValidDropboxPath(file.path_lower));
  if (validFiles.length === 0) return {};

  const supportsWebP = await checkWebPSupport(); // use your existing helper
  const format = supportsWebP ? "webp" : "jpeg";
  // const format = supportsWebP ? "webp" : "jpeg";

  for (let i = 0; i < validFiles.length; i += batchSize) {
    const batch = validFiles.slice(i, i + batchSize);

    if (onProgress) {
      onProgress({
        current: i + 1,
        total: validFiles.length,
        batch: Math.floor(i / batchSize) + 1,
        totalBatches: Math.ceil(validFiles.length / batchSize),
        message: `Loading images ${i + 1}-${Math.min(i + batchSize, validFiles.length)} of ${validFiles.length}`,
      });
    }

    let retryCount = 0;
    let batchSuccess = false;

    while (retryCount <= maxRetries && !batchSuccess) {
      try {
        const entries = batch.map((file) => ({
          path: file.path_lower,
          format,
          size,
          mode,
        }));

        const response = await withRateLimitRetry(
          () => dbx.filesGetThumbnailBatch({ entries }),
          "getThumbnails"
        );
        const result = response.result;

        const batchThumbs = result.entries.reduce((acc, entry) => {
          if (entry?.[".tag"] === "success" && entry.metadata && entry.thumbnail) {
            acc[entry.metadata.path_lower] = entry.thumbnail;
          }
          return acc;
        }, {});

        Object.assign(allThumbnails, batchThumbs);
        if (onBatch && Object.keys(batchThumbs).length > 0) {
          try {
            onBatch(batchThumbs);
          } catch (cbErr) {
            console.error("onBatch callback error:", cbErr);
          }
        }
        batchSuccess = true;
      } catch (error) {
        retryCount++;
        if (error.status === 400 || error.status === 409) {
          console.warn(`Skipping batch due to error ${error.status}`);
          break;
        } else {
          console.error("Unexpected error loading batch:", error);
          break;
        }
      }
    }

    if (!batchSuccess && retryCount > maxRetries) {
      console.error(`Failed to load batch after ${maxRetries + 1} attempts`);
    }

    if (i + batchSize < validFiles.length) {
      await sleep(delayBetweenBatches); // use your existing helper
    }
  }
  return allThumbnails;
};

// Path validation function
const isValidDropboxPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  // Check for basic path validity
  if (path.includes('//') || path.includes('\\')) return false;
  if (path.length > 500) return false; // Dropbox path length limit
  return true;
};

// Enhanced function with rate limiting and retry logic (CONSERVATIVE VERSION)
const getThumbnailsWithRateLimit = async (
  files,
  options = {},
  onProgress = null
) => {
  console.log(`🖼️ getThumbnailsWithRateLimit: Starting thumbnail loading for ${files ? files.length : 0} files`);

  if (!files || files.length === 0) {
    console.log(`⚠️ getThumbnailsWithRateLimit: No files provided`);
    return {};
  }

  const {
    batchSize = 2, // MUCH smaller batches
    delayBetweenBatches = 1800, // 3 seconds between batches
    maxRetries = 8, // Fewer retries
    ...thumbnailOptions
  } = options;


  const allThumbnails = {};
  const totalFiles = files.length;

  // Validate all file paths before processing
  const validFiles = files.filter(file => {
    if (!isValidDropboxPath(file.path_lower)) {
      // console.warn(`⚠️ getThumbnailsWithRateLimit: Skipping invalid file path: ${file.path_lower}`);
      return false;
    }
    return true;
  });

  // console.log(`✅ getThumbnailsWithRateLimit: ${validFiles.length} out of ${totalFiles} files have valid paths`);

  if (validFiles.length === 0) {
    console.warn('❌ getThumbnailsWithRateLimit: No valid files to process');
    return {};
  }

  for (let i = 0; i < validFiles.length; i += batchSize) {
    const batch = validFiles.slice(i, i + batchSize);
    const batchNumber = Math.floor(i / batchSize) + 1;
    const totalBatches = Math.ceil(validFiles.length / batchSize);

    // console.log(`🔄 getThumbnailsWithRateLimit: Processing batch ${batchNumber}/${totalBatches} with ${batch.length} files`);

    // Update progress
    if (onProgress) {
      onProgress({
        current: i + 1,
        total: totalFiles,
        batch: batchNumber,
        totalBatches,
        message: `Loading images ${i + 1}-${Math.min(
          i + batchSize,
          totalFiles
        )} of ${totalFiles}`,
      });
    }

    let retryCount = 0;
    let batchSuccess = false;

    while (retryCount <= maxRetries && !batchSuccess) {
      try {
        // console.log(`🎯 getThumbnailsWithRateLimit: Calling getThumbnails for batch ${batchNumber} (attempt ${retryCount + 1})`);
        const batchThumbs = await getThumbnails(batch, thumbnailOptions);
        const thumbCount = Object.keys(batchThumbs).length;
        // console.log(`✅ getThumbnailsWithRateLimit: Batch ${batchNumber} success - got ${thumbCount} thumbnails out of ${batch.length} files`);
        Object.assign(allThumbnails, batchThumbs);
        batchSuccess = true;
      } catch (error) {
        retryCount++;
        // console.log(`❌ getThumbnailsWithRateLimit: Batch ${batchNumber} failed (attempt ${retryCount}):`, error.status, error.message);

        // Handle specific error codes
        if (error.status === 400) {
          console.error(`🚫 getThumbnailsWithRateLimit: Bad request error for batch ${batchNumber}, skipping`);
          // Skip this batch entirely for 400 errors
          break;
        } else if (error.status === 409) {
          console.warn(`⚠️ getThumbnailsWithRateLimit: Conflict error for batch ${batchNumber}, skipping`);
          // Skip this batch for 409 errors  
          break;
        } else {
          console.error(`💥 getThumbnailsWithRateLimit: Error loading batch ${batchNumber}, not retrying:`, error);
          break; // Don't retry other errors
        }
      }
    }

    if (!batchSuccess && retryCount > maxRetries) {
      console.error(
        `💀 getThumbnailsWithRateLimit: Failed to load batch ${batchNumber} after ${maxRetries + 1} attempts`
      );
    }

    // Always add delay between batches (unless this is the last batch)
    if (i + batchSize < validFiles.length) {
      // console.log(`⏳ getThumbnailsWithRateLimit: Waiting ${delayBetweenBatches}ms before next batch`);
      await sleep(delayBetweenBatches);
    }
  }

  // console.log(`🏁 getThumbnailsWithRateLimit: Completed! Got ${Object.keys(allThumbnails).length} thumbnails out of ${validFiles.length} valid files`);
  return allThumbnails;
};

// Function to get direct full resolution URLs using shared links with raw=1
const getFullResolutionUrls = async (files, onProgress = null) => {
  if (!files || files.length === 0) {
    return {};
  }

  const allUrls = {};
  const batchSize = 2; // Very small batches to avoid API limits
  const maxRetries = 8;
  const baseDelay = 1800; // Base delay between retries

  for (let i = 0; i < files.length; i += batchSize) {
    const batch = files.slice(i, Math.min(i + batchSize, files.length));
    const batchNumber = Math.floor(i / batchSize) + 1;
    const totalBatches = Math.ceil(files.length / batchSize);

    // Processing batch ${batchNumber}/${totalBatches} with ${batch.length} files

    if (onProgress) {
      onProgress({
        current: i + 1,
        total: files.length,
        message: `Getting full resolution URLs ${i + 1}-${Math.min(i + batchSize, files.length)} of ${files.length}`,
      });
    }

    // Process each file in the batch
    for (const file of batch) {
      let retryCount = 0;
      let success = false;

      while (!success && retryCount < maxRetries) {
        try {
          // First try to get existing shared links
          const existingLinks = await withRateLimitRetry(
            () =>
              dbx.sharingListSharedLinks({
                path: file.path_lower,
                direct_only: true,
              }),
            "getFullResolutionUrls"
          );

          let directUrl;

          if (existingLinks.result.links.length > 0) {
            // Use existing link
            directUrl = existingLinks.result.links[0].url;
          } else {
            // Create new shared link if none exists
            const sharedLinkResponse = await withRateLimitRetry(
              () =>
                dbx.sharingCreateSharedLinkWithSettings({
                  path: file.path_lower,
                  settings: {
                    requested_visibility: "public",
                    audience: "public",
                    access: "viewer",
                  },
                }),
              "getFullResolutionUrls"
            );
            directUrl = sharedLinkResponse.result.url;
          }

          // Convert to raw URL
          if (directUrl.includes('?dl=0')) {
            directUrl = directUrl.replace('?dl=0', '?raw=1');
          } else if (directUrl.includes('&dl=0')) {
            directUrl = directUrl.replace('&dl=0', '&raw=1');
          } else {
            directUrl += directUrl.includes('?') ? '&raw=1' : '?raw=1';
          }

          allUrls[file.path_lower] = directUrl;
          success = true;

        } catch (error) {
          retryCount++;

          if (error.status === 409 && retryCount < maxRetries) {
            // Calculate delay with exponential backoff
            const delay = baseDelay * Math.pow(2, retryCount - 1);
            await sleep(delay);
          } else {
            console.error(`Failed to process ${file.name}:`, error.message);
            break; // Exit retry loop for non-recoverable errors
          }
        }
      }

      if (!success) {
        console.error(`Failed to process ${file.name} after ${maxRetries} attempts`);
      }
    }

    // Add small delay between batches to prevent rate limiting
    if (i + batchSize < files.length) {
      await sleep(baseDelay);
    }
  }

  return allUrls;
};

// Function to get full resolution images (for Storyboards)
const getFullResImages = async (files, onProgress = null) => {
  if (!files || files.length === 0) return {};

  const allImages = {};
  const batchSize = 5; // Even smaller batches for full res
  const delayBetweenBatches = 2000; // 2 seconds between batches

  for (let i = 0; i < files.length; i += batchSize) {
    const batch = files.slice(i, i + batchSize);

    if (onProgress) {
      onProgress({
        current: i + 1,
        total: files.length,
        message: `Loading full resolution images ${i + 1}-${Math.min(
          i + batchSize,
          files.length
        )} of ${files.length}`,
      });
    }

    // Process each file in the batch
    for (const file of batch) {
      try {
        // Use shared link to get file content
        const sharedLinkResponse =
          await dbx.sharingCreateSharedLinkWithSettings({
            path: file.path_lower,
            settings: {
              requested_visibility: "public",
              audience: "public",
              access: "viewer",
            },
          });

        // Convert shared link to direct download
        const directUrl = sharedLinkResponse.result.url.replace(
          "?dl=0",
          "?raw=1"
        );

        // Fetch the image and convert to base64
        const imageResponse = await fetch(directUrl);
        const imageBlob = await imageResponse.blob();
        const base64 = await blobToBase64(imageBlob);

        allImages[file.path_lower] = base64.split(",")[1]; // Remove data:image/jpeg;base64, prefix
      } catch (error) {
        console.error(`Error loading full res image ${file.name}:`, error);
        // Fallback to thumbnail for this image
        try {
          const fallbackThumbs = await getThumbnails([file], {
            size: "w2048h1536",
          });
          Object.assign(allImages, fallbackThumbs);
        } catch (fallbackError) {
          console.error(
            `Fallback thumbnail also failed for ${file.name}:`,
            fallbackError
          );
        }
      }
    }

    // Delay between batches
    if (i + batchSize < files.length) {
      await sleep(delayBetweenBatches);
    }
  }

  return allImages;
};

// Helper function to convert blob to base64
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Retries Dropbox API calls when the service returns a 429 (rate limited).
const withRateLimitRetry = async (fn, context = "Dropbox API") => {
  while (true) {
    try {
      return await fn();
    } catch (error) {
      if (error?.status === 429) {
        const retryHeader =
          error?.headers?.["retry-after"] ?? error?.headers?.["Retry-After"];
        const retryAfterSeconds = Number(retryHeader);
        const retryDelayMs =
          Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
            ? retryAfterSeconds * 1000
            : 60000;
        console.warn(
          `${context}: Hit Dropbox rate limit (429). Retrying in ${retryDelayMs / 1000
          }s...`
        );
        await sleep(retryDelayMs);
        continue;
      }
      throw error;
    }
  }
};

async function getAllFiles(path, onUpdate = null) {
  try {
    let entries = [];
    let cursor = null;

    do {
      const listResult = cursor
        ? await withRateLimitRetry(
          () => dbx.filesListFolderContinue({ cursor }),
          "getAllFiles"
        )
        : await withRateLimitRetry(
          () =>
            dbx.filesListFolder({
              path,
              recursive: true,
              include_media_info: true,
            }),
          "getAllFiles"
        );

      entries = [...entries, ...listResult.result.entries];
      cursor = listResult.result.has_more ? listResult.result.cursor : null;
    } while (cursor);

    const filteredEntries = entries.filter(
      (entry) =>
        entry &&
        entry[".tag"] === "file" &&
        entry.path_lower &&
        entry.path_lower.match(/\.(jpg|jpeg|png)$/i)
    );

    const files = filteredEntries.map((entry) => ({
      ...entry,
      url: null,
    }));

    if (onUpdate) onUpdate(files);

    for (let i = 0; i < files.length; i++) {
      const entry = files[i];
      if (entry[".tag"] === "file") {
        try {
          const tempLink = await withRateLimitRetry(
            () =>
              dbx.filesGetTemporaryLink({
                path: entry.path_display,
              }),
            "getAllFiles"
          );
          files[i] = { ...entry, url: tempLink.result.link };
          if (onUpdate) onUpdate(files);
        } catch (error) {
          console.error(`Error getting link for ${entry.path_display}:`, error);
        }
      }
    }

    return files;
  } catch (error) {
    console.error("Error listing files:", error);
    throw error;
  }
}

async function batchCopyToClientSelects(files, basePath) {
  const now = new Date();
  const dateString = `${now.getFullYear()}-${String(
    now.getMonth() + 1
  ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} - ${String(
    now.getHours() % 12 || 12
  ).padStart(2, "0")}.${String(now.getMinutes()).padStart(2, "0")} ${now.getHours() >= 12 ? "pm" : "am"
    }`;

  const destinationFolder = `${basePath}/Client Selects/${dateString}`;

  try {
    await dbx
      .filesCreateFolderV2({
        path: `${basePath}/Client Selects`,
        autorename: false,
      })
      .catch((error) => {
        if (!error.error.error_summary.includes("path/conflict/folder")) {
          throw error;
        }
      });

    await dbx.filesCreateFolderV2({
      path: destinationFolder,
      autorename: false,
    });

    const entries = files.map((file) => ({
      from_path: file.path_display,
      to_path: `${destinationFolder}/${file.name}`,
    }));

    const batchResult = await dbx.filesCopyBatchV2({ entries });

    const asyncJobId = batchResult.result.async_job_id;

    // Poll for job completion
    let isComplete = false;
    while (!isComplete) {
      await sleep(2000);
      const jobResult = await dbx.filesCopyBatchCheckV2({
        async_job_id: asyncJobId,
      });

      if (jobResult.result[".tag"] === "complete") {

        isComplete = true;
        return {
          success: true,
          folder: destinationFolder,
        };
      } else if (jobResult.result[".tag"] === "failed") {
        throw new Error(
          `Batch operation failed: ${JSON.stringify(jobResult.result.failed)}`
        );
      }
      // If still in progress, continue polling
    }
  } catch (error) {
    console.error("Detailed error in batch copy:", error);
    return {
      success: false,
      error: error.message || "Unknown error occurred",
    };
  }
}

// Helper function to chunk array for concurrent processing
function chunkArray(array, chunkSize) {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

// Upload single file with retry logic
async function uploadSingleFile(file, destinationPath, abortSignal = null) {
  const filePath = `${destinationPath}/${file.name}`;

  if (abortSignal && abortSignal.aborted) {
    throw new DOMException("Upload cancelled", "AbortError");
  }

  try {
    if (file.size > 8 * 1024 * 1024) {
      // 8MB
      return await uploadLargeFile(file, filePath, abortSignal);
    } else {
      const contents = await file.arrayBuffer();

      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }

      const result = await dbx.filesUpload({
        path: filePath,
        contents: contents,
        mode: "add",
        autorename: true,
      });
      return { success: true, file: file.name, result };
    }
  } catch (error) {
    return { success: false, file: file.name, error: error.message };
  }
}

// Optimized concurrent batch upload function
async function uploadFilesToDropboxConcurrent(
  files,
  destinationPath,
  onProgress = null,
  abortSignal = null,
  concurrency = 5
) {
  try {
    // Ensure destination folder exists
    await dbx
      .filesCreateFolderV2({
        path: destinationPath,
        autorename: false,
      })
      .catch((error) => {
        if (!error.error.error_summary.includes("path/conflict/folder")) {
          throw error;
        }
      });

    const results = [];
    const fileArray = Array.from(files);
    let completedFiles = 0;

    // Split files into concurrent batches
    const batches = chunkArray(fileArray, concurrency);

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }

      const batch = batches[batchIndex];

      // Process batch concurrently
      const batchPromises = batch.map(async (file) => {
        if (onProgress) {
          onProgress({
            currentFile: completedFiles + 1,
            totalFiles: fileArray.length,
            fileName: file.name,
            percentage: (completedFiles / fileArray.length) * 100,
            status: "uploading",
            completedFiles,
          });
        }

        const result = await uploadSingleFile(
          file,
          destinationPath,
          abortSignal
        );

        if (result.success) {
          completedFiles++;
        }

        return result;
      });

      // Wait for batch to complete
      const batchResults = await Promise.allSettled(batchPromises);

      // Process results
      batchResults.forEach((promiseResult) => {
        if (promiseResult.status === "fulfilled") {
          results.push(promiseResult.value);
        } else {
          results.push({
            success: false,
            file: "unknown",
            error: promiseResult.reason?.message || "Unknown error",
          });
        }
      });

      // Update progress after batch completion
      if (onProgress) {
        onProgress({
          currentFile: completedFiles,
          totalFiles: fileArray.length,
          fileName: `Batch ${batchIndex + 1}/${batches.length} completed`,
          percentage: (completedFiles / fileArray.length) * 100,
          status: "completed",
          completedFiles,
          batchesCompleted: batchIndex + 1,
          totalBatches: batches.length,
        });
      }
    }

    return {
      success: true,
      results,
      totalFiles: fileArray.length,
      successfulUploads: results.filter((r) => r.success).length,
      failedUploads: results.filter((r) => !r.success).length,
    };
  } catch (error) {
    console.error("Error in concurrent batch upload:", error);
    return {
      success: false,
      error: error.message || "Unknown error occurred",
      results: [],
    };
  }
}

// Legacy sequential upload function (for compatibility)
async function uploadFilesToDropbox(
  files,
  destinationPath,
  onProgress = null,
  abortSignal = null
) {
  try {
    // Ensure destination folder exists
    await dbx
      .filesCreateFolderV2({
        path: destinationPath,
        autorename: false,
      })
      .catch((error) => {
        if (!error.error.error_summary.includes("path/conflict/folder")) {
          throw error;
        }
      });

    const results = [];
    let completedFiles = 0;

    for (let i = 0; i < files.length; i++) {
      // Check for abort signal
      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }

      const file = files[i];

      if (onProgress) {
        onProgress({
          currentFile: i + 1,
          totalFiles: files.length,
          fileName: file.name,
          percentage: (i / files.length) * 100,
          status: "uploading",
        });
      }

      try {
        // For large files, use upload session
        if (file.size > 8 * 1024 * 1024) {
          // 8MB
          const result = await uploadLargeFile(
            file,
            `${destinationPath}/${file.name}`,
            abortSignal
          );
          results.push({ success: true, file: file.name, result });
        } else {
          // For smaller files, use simple upload
          const contents = await file.arrayBuffer();

          // Check for abort before upload
          if (abortSignal && abortSignal.aborted) {
            throw new DOMException("Upload cancelled", "AbortError");
          }

          const result = await dbx.filesUpload({
            path: `${destinationPath}/${file.name}`,
            contents: contents,
            mode: "add",
            autorename: true,
          });
          results.push({ success: true, file: file.name, result });
        }

        completedFiles++;

        if (onProgress) {
          onProgress({
            currentFile: i + 1,
            totalFiles: files.length,
            fileName: file.name,
            percentage: ((i + 1) / files.length) * 100,
            status: "completed",
            completedFiles,
          });
        }
      } catch (error) {
        console.error(`Error uploading ${file.name}:`, error);
        results.push({ success: false, file: file.name, error: error.message });

        if (onProgress) {
          onProgress({
            currentFile: i + 1,
            totalFiles: files.length,
            fileName: file.name,
            percentage: ((i + 1) / files.length) * 100,
            status: "error",
            error: error.message,
            completedFiles,
          });
        }
      }

      // No artificial delay - let Dropbox API handle rate limiting naturally
    }

    return {
      success: true,
      results,
      totalFiles: files.length,
      successfulUploads: results.filter((r) => r.success).length,
      failedUploads: results.filter((r) => !r.success).length,
    };
  } catch (error) {
    console.error("Error in batch upload:", error);
    return {
      success: false,
      error: error.message || "Unknown error occurred",
      results: [],
    };
  }
}

// Upload large files using upload session with cancellation support
async function uploadLargeFile(file, destinationPath, abortSignal = null) {
  const chunkSize = 8 * 1024 * 1024; // 8MB chunks
  const contents = await file.arrayBuffer();
  const totalSize = contents.byteLength;

  // Check for abort before starting
  if (abortSignal && abortSignal.aborted) {
    throw new DOMException("Upload cancelled", "AbortError");
  }

  if (totalSize <= chunkSize) {
    // File is small enough for simple upload
    return await dbx.filesUpload({
      path: destinationPath,
      contents: contents,
      mode: "add",
      autorename: true,
    });
  }

  // Start upload session
  const sessionStart = await dbx.filesUploadSessionStart({
    contents: contents.slice(0, chunkSize),
  });

  const sessionId = sessionStart.result.session_id;
  let offset = chunkSize;

  // Upload remaining chunks
  while (offset < totalSize) {
    // Check for abort before each chunk
    if (abortSignal && abortSignal.aborted) {
      throw new DOMException("Upload cancelled", "AbortError");
    }

    const chunkEnd = Math.min(offset + chunkSize, totalSize);
    const chunk = contents.slice(offset, chunkEnd);
    const isLastChunk = chunkEnd === totalSize;

    if (isLastChunk) {
      // Finish the session
      return await dbx.filesUploadSessionFinish({
        cursor: {
          session_id: sessionId,
          offset: offset,
        },
        commit: {
          path: destinationPath,
          mode: "add",
          autorename: true,
        },
        contents: chunk,
      });
    } else {
      // Continue the session
      await dbx.filesUploadSessionAppendV2({
        cursor: {
          session_id: sessionId,
          offset: offset,
        },
        contents: chunk,
      });
    }

    offset = chunkEnd;
  }
}

// Create folder with subfolders
async function createDropboxFolder(path) {
  try {
    await dbx.filesCreateFolderV2({
      path: path,
      autorename: false,
    });
    return { success: true };
  } catch (error) {
    if (error.error.error_summary.includes("path/conflict/folder")) {
      return { success: true, message: "Folder already exists" };
    }
    console.error("Error creating folder:", error);
    return { success: false, error: error.message };
  }
}

// Upload files with folder structure preservation (concurrent version)
async function uploadFilesWithFolderStructureConcurrent(
  files,
  basePath,
  onProgress = null,
  abortSignal = null,
  concurrency = 5
) {
  try {
    const results = [];
    const fileArray = Array.from(files);
    let completedFiles = 0;

    // Create all necessary folders first
    const folders = new Set();
    fileArray.forEach((file) => {
      if (file.webkitRelativePath) {
        const pathParts = file.webkitRelativePath.split("/");
        pathParts.pop(); // Remove filename
        let currentPath = basePath;
        pathParts.forEach((part) => {
          currentPath += "/" + part;
          folders.add(currentPath);
        });
      }
    });

    // Create folders
    for (const folderPath of folders) {
      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }
      await createDropboxFolder(folderPath);
    }

    // Split files into concurrent batches
    const batches = chunkArray(fileArray, concurrency);

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }

      const batch = batches[batchIndex];

      // Process batch concurrently
      const batchPromises = batch.map(async (file) => {
        const relativePath = file.webkitRelativePath || file.name;
        const fullPath = `${basePath}/${relativePath}`;

        if (onProgress) {
          onProgress({
            currentFile: completedFiles + 1,
            totalFiles: fileArray.length,
            fileName: relativePath,
            percentage: (completedFiles / fileArray.length) * 100,
            status: "uploading",
            completedFiles,
          });
        }

        try {
          let result;
          // Upload file
          if (file.size > 8 * 1024 * 1024) {
            result = await uploadLargeFile(file, fullPath, abortSignal);
          } else {
            const contents = await file.arrayBuffer();

            if (abortSignal && abortSignal.aborted) {
              throw new DOMException("Upload cancelled", "AbortError");
            }

            result = await dbx.filesUpload({
              path: fullPath,
              contents: contents,
              mode: "add",
              autorename: true,
            });
          }

          completedFiles++;
          return { success: true, file: relativePath, result };
        } catch (error) {
          console.error(`Error uploading ${relativePath}:`, error);
          return { success: false, file: relativePath, error: error.message };
        }
      });

      // Wait for batch to complete
      const batchResults = await Promise.allSettled(batchPromises);

      // Process results
      batchResults.forEach((promiseResult) => {
        if (promiseResult.status === "fulfilled") {
          results.push(promiseResult.value);
        } else {
          results.push({
            success: false,
            file: "unknown",
            error: promiseResult.reason?.message || "Unknown error",
          });
        }
      });

      // Update progress after batch completion
      if (onProgress) {
        onProgress({
          currentFile: completedFiles,
          totalFiles: fileArray.length,
          fileName: `Batch ${batchIndex + 1}/${batches.length} completed`,
          percentage: (completedFiles / fileArray.length) * 100,
          status: "completed",
          completedFiles,
          batchesCompleted: batchIndex + 1,
          totalBatches: batches.length,
        });
      }
    }

    return {
      success: true,
      results,
      totalFiles: fileArray.length,
      successfulUploads: results.filter((r) => r.success).length,
      failedUploads: results.filter((r) => !r.success).length,
    };
  } catch (error) {
    console.error("Error in concurrent folder structure upload:", error);
    return {
      success: false,
      error: error.message || "Unknown error occurred",
      results: [],
    };
  }
}

// Upload files with folder structure preservation (sequential legacy version)
async function uploadFilesWithFolderStructure(
  files,
  basePath,
  onProgress = null,
  abortSignal = null
) {
  try {
    const results = [];
    let completedFiles = 0;
    const fileArray = Array.from(files);

    // Create all necessary folders first
    const folders = new Set();
    fileArray.forEach((file) => {
      if (file.webkitRelativePath) {
        const pathParts = file.webkitRelativePath.split("/");
        pathParts.pop(); // Remove filename
        let currentPath = basePath;
        pathParts.forEach((part) => {
          currentPath += "/" + part;
          folders.add(currentPath);
        });
      }
    });

    // Create folders
    for (const folderPath of folders) {
      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }
      await createDropboxFolder(folderPath);
    }

    // Upload files with preserved structure
    for (let i = 0; i < fileArray.length; i++) {
      if (abortSignal && abortSignal.aborted) {
        throw new DOMException("Upload cancelled", "AbortError");
      }

      const file = fileArray[i];
      const relativePath = file.webkitRelativePath || file.name;
      const fullPath = `${basePath}/${relativePath}`;

      if (onProgress) {
        onProgress({
          currentFile: i + 1,
          totalFiles: fileArray.length,
          fileName: relativePath,
          percentage: (i / fileArray.length) * 100,
          status: "uploading",
        });
      }

      try {
        // Upload file
        if (file.size > 8 * 1024 * 1024) {
          const result = await uploadLargeFile(file, fullPath, abortSignal);
          results.push({ success: true, file: relativePath, result });
        } else {
          const contents = await file.arrayBuffer();

          if (abortSignal && abortSignal.aborted) {
            throw new DOMException("Upload cancelled", "AbortError");
          }

          const result = await dbx.filesUpload({
            path: fullPath,
            contents: contents,
            mode: "add",
            autorename: true,
          });
          results.push({ success: true, file: relativePath, result });
        }

        completedFiles++;

        if (onProgress) {
          onProgress({
            currentFile: i + 1,
            totalFiles: fileArray.length,
            fileName: relativePath,
            percentage: ((i + 1) / fileArray.length) * 100,
            status: "completed",
            completedFiles,
          });
        }
      } catch (error) {
        console.error(`Error uploading ${relativePath}:`, error);
        results.push({
          success: false,
          file: relativePath,
          error: error.message,
        });
      }

      // No artificial delay - let Dropbox API handle rate limiting naturally
    }

    return {
      success: true,
      results,
      totalFiles: fileArray.length,
      successfulUploads: results.filter((r) => r.success).length,
      failedUploads: results.filter((r) => !r.success).length,
    };
  } catch (error) {
    console.error("Error in folder structure upload:", error);
    return {
      success: false,
      error: error.message || "Unknown error occurred",
      results: [],
    };
  }
}

// Scan folder structure without loading thumbnails - just get file paths and organize
const scanFolderStructure = async (path = "") => {
  // console.log(`🔍 scanFolderStructure: Scanning folder structure for path: "${path}"`);

  try {
    let allEntries = [];
    let currentCursor = null;
    let pageCount = 0;

    // Continue fetching until we have all files (handle pagination)
    do {
      pageCount++;
      let response;

      if (currentCursor) {
        // console.log(`🔄 scanFolderStructure: Fetching page ${pageCount} with cursor`);
        response = await withRateLimitRetry(
          () => dbx.filesListFolderContinue({ cursor: currentCursor }),
          "scanFolderStructure"
        );
      } else {
        // console.log(`🔄 scanFolderStructure: Fetching page ${pageCount} (initial) with recursive=true`);
        response = await withRateLimitRetry(
          () =>
            dbx.filesListFolder({
              path,
              recursive: true,
              include_media_info: false, // Don't need media info for structure scanning
              limit: 2000,
            }),
          "scanFolderStructure"
        );
      }

      const result = response.result;
      // console.log(`📊 scanFolderStructure: Page ${pageCount} contains ${result.entries.length} entries, has_more: ${result.has_more}`);

      // Add this page's entries to our collection
      allEntries = [...allEntries, ...result.entries];

      // Update cursor for next iteration
      currentCursor = result.has_more ? result.cursor : null;

    } while (currentCursor);

    // console.log(`📦 scanFolderStructure: Collected ${allEntries.length} total entries across ${pageCount} pages`);

    // Filter to get only image files (JPG/JPEG/PNG)
    const filesOnly = allEntries.filter(entry => entry && entry[".tag"] === "file");
    const imageFiles = filesOnly.filter(entry =>
      entry.path_lower && entry.path_lower.match(/\.(jpg|jpeg|png)$/i)
    );

    // Add placeholder thumbnailUrl to maintain compatibility
    const structureFiles = imageFiles.map(file => ({
      ...file,
      thumbnailUrl: null,
      thumbnailSize: null,
    }));

    // console.log(`🗂️ scanFolderStructure: Found ${structureFiles.length} image files in folder structure`);

    return {
      entries: structureFiles,
      hasMore: false,
      cursor: null,
    };
  } catch (error) {
    console.error(`❌ scanFolderStructure: Error scanning folder "${path}":`, error);
    return {
      entries: [],
      hasMore: false,
      cursor: null,
    };
  }
};

// NEW FUNCTION: Load images progressively with individual callbacks
const loadImagesProgressively = async (files, options = {}, onImageLoaded = null) => {
  // console.log(`🚀 loadImagesProgressively: Starting progressive loading for ${files ? files.length : 0} files`);

  if (!files || files.length === 0) {
    // console.log(`⚠️ loadImagesProgressively: No files provided`);
    return;
  }

  const {
    type = 'thumbnail', // 'thumbnail' or 'fullres'
    batchSize = 3,
    delayBetweenImages = 100, // Small delay between individual images
    thumbnailOptions = {
      size: "w2048h1536",
      format: "png",
      mode: "fitone_bestfit",
    }
  } = options;

  // console.log(`⚙️ loadImagesProgressively: Using settings - type: ${type}, batchSize: ${batchSize}`);

  // Process images one by one or in small batches
  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    try {
      if (type === 'fullres') {
        // Get full resolution URL for this single image
        // console.log(`🎯 loadImagesProgressively: Getting full res URL for ${file.name}`);

        try {
          // Try to create a shared link
          const sharedLinkResponse = await dbx.sharingCreateSharedLinkWithSettings({
            path: file.path_lower,
            settings: {
              requested_visibility: "public",
              audience: "public",
              access: "viewer",
            },
          }).catch(async (error) => {
            // If link already exists, get it
            if (error.status === 409) {
              const existingLinks = await dbx.sharingListSharedLinks({
                path: file.path_lower,
                direct_only: true,
              });
              if (existingLinks.result.links.length > 0) {
                return { result: { url: existingLinks.result.links[0].url } };
              }
            }
            throw error;
          });

          // Convert to direct URL
          let directUrl = sharedLinkResponse.result.url;
          directUrl = directUrl.replace('?dl=0', '?raw=1').replace('&dl=0', '&raw=1');
          if (!directUrl.includes('raw=1')) {
            directUrl += directUrl.includes('?') ? '&raw=1' : '?raw=1';
          }

          // Call the callback immediately with this image
          if (onImageLoaded) {
            onImageLoaded(file.path_lower, directUrl, i + 1, files.length);
          }

          // console.log(`✅ loadImagesProgressively: Loaded full res for ${file.name}`);
        } catch (error) {
          console.error(`❌ loadImagesProgressively: Error loading full res for ${file.name}:`, error);
        }

      } else {
        // Get thumbnail for this single image
        // console.log(`🎯 loadImagesProgressively: Getting thumbnail for ${file.name}`);

        try {
          const entries = [{
            path: file.path_lower,
            format: thumbnailOptions.format,
            size: thumbnailOptions.size,
            mode: thumbnailOptions.mode,
          }];

          const response = await withRateLimitRetry(
            () => dbx.filesGetThumbnailBatch({ entries }),
            "loadImagesProgressively"
          );
          const result = response.result;

          // Process the result and call callback immediately
          if (result.entries && result.entries[0] && result.entries[0][".tag"] === "success") {
            const entry = result.entries[0];
            if (entry.metadata && entry.thumbnail) {
              // Call the callback immediately with this image
              if (onImageLoaded) {
                onImageLoaded(entry.metadata.path_lower, entry.thumbnail, i + 1, files.length);
              }
              // console.log(`✅ loadImagesProgressively: Loaded thumbnail for ${file.name}`);
            }
          }
        } catch (error) {
          console.error(`❌ loadImagesProgressively: Error loading thumbnail for ${file.name}:`, error);
        }
      }

      // Small delay between images to avoid rate limiting
      if (i < files.length - 1 && delayBetweenImages > 0) {
        await sleep(delayBetweenImages);
      }

    } catch (error) {
      console.error(`❌ loadImagesProgressively: Error processing ${file.name}:`, error);
    }
  }

  // console.log(`🏁 loadImagesProgressively: Completed processing all ${files.length} files`);
};

// Smart supply folder detection that goes one layer deeper when appropriate
const listSupplyFoldersWithSmartDepth = async (supplyPath = "") => {
  try {
    const smartFolders = [];
    const t0 = performance.now();

    // Single call — get files AND subfolders in one round trip
    let allEntries = [];
    try {
      let currentCursor = null;
      do {
        let response;
        if (currentCursor) {
          response = await withRateLimitRetry(
            () => dbx.filesListFolderContinue({ cursor: currentCursor }),
            "listSupplyFoldersWithSmartDepth"
          );
        } else {
          response = await withRateLimitRetry(
            () => dbx.filesListFolder({ path: supplyPath, recursive: false, include_media_info: false }),
            "listSupplyFoldersWithSmartDepth"
          );
        }
        allEntries = [...allEntries, ...response.result.entries];
        currentCursor = response.result.has_more ? response.result.cursor : null;
      } while (currentCursor);
    } catch (error) {
      console.warn(`Error listing supply folder contents:`, error);
    }

    console.log(`⏱️ [Supply] root listing: ${(performance.now() - t0).toFixed(0)}ms (${allEntries.length} entries)`);

    const looseFiles = allEntries.filter(e => e && e[".tag"] === "file");
    const directSubfolderEntries = allEntries.filter(e => e && e[".tag"] === "folder");

    if (looseFiles.length > 0) {
      console.log(`📁 Supply folder has ${looseFiles.length} loose files, adding as "Supply" folder`);
      smartFolders.push({
        name: "Supply",
        path_display: supplyPath,
        path_lower: supplyPath.toLowerCase(),
        isLooseSupplyFolder: true,
        isSmartDeepFolder: false
      });
    }

    if (directSubfolderEntries.length > 0) {
      console.log(`⏱️ [Supply] checking ${directSubfolderEntries.length} subfolders (concurrency 3)...`);

      // Probe subfolders with capped concurrency to stay under Dropbox rate limits
      const CONCURRENCY = 3;
      const probeFolder = async (folder) => {
        const folderPath = `${supplyPath}/${folder.name}`;
        const tSub = performance.now();
        try {
          // Fully list the subfolder's contents (paginated). We need the COMPLETE
          // list because when this folder is "smart deep" we render every child as
          // "Parent / Child" — a limit here drops sibling folders.
          let subEntries = [];
          let subCursor = null;
          do {
            const folderContents = await withRateLimitRetry(
              () =>
                subCursor
                  ? dbx.filesListFolderContinue({ cursor: subCursor })
                  : dbx.filesListFolder({
                      path: folderPath,
                      recursive: false,
                      include_media_info: false,
                    }),
              "listSupplyFoldersWithSmartDepth"
            );
            subEntries = [...subEntries, ...folderContents.result.entries];
            subCursor = folderContents.result.has_more ? folderContents.result.cursor : null;
          } while (subCursor);

          console.log(`⏱️ [Supply] subfolder "${folder.name}": ${(performance.now() - tSub).toFixed(0)}ms`);

          const subfolders = subEntries.filter(entry => entry && entry[".tag"] === "folder");
          const files = subEntries.filter(entry => entry && entry[".tag"] === "file");

          if (subfolders.length > 0 && files.length === 0) {
            console.log(`📁 Smart detection: "${folder.name}" has ${subfolders.length} subfolders, going deeper`);
            return subfolders.map((subfolder) => {
              const deepFolderPath = `${folderPath}/${subfolder.name}`;
              console.log(`  📂 Adding deep folder: "${folder.name} / ${subfolder.name}" with path: ${deepFolderPath}`);
              const { icon, ...subfolderData } = subfolder;
              return {
                ...subfolderData,
                name: `${subfolder.name}`,
                path_display: deepFolderPath,
                path_lower: deepFolderPath.toLowerCase(),
                parentFolder: folder.name,
                subfolderName: subfolder.name,
                isSmartDeepFolder: true
              };
            });
          } else {
            console.log(`📁 Smart detection: "${folder.name}" has ${files.length} files directly, keeping original`);
            const { icon, ...folderData } = folder;
            return [{
              ...folderData,
              path_display: folderPath,
              path_lower: folderPath.toLowerCase(),
              isSmartDeepFolder: false
            }];
          }
        } catch (error) {
          console.error(`Error checking contents of ${folderPath}:`, error);
          const { icon, ...folderData } = folder;
          return [{
            ...folderData,
            path_display: folderPath,
            path_lower: folderPath.toLowerCase(),
            isSmartDeepFolder: false
          }];
        }
      };

      // Run probes with capped concurrency
      let idx = 0;
      const worker = async () => {
        while (idx < directSubfolderEntries.length) {
          const folder = directSubfolderEntries[idx++];
          const results = await probeFolder(folder);
          smartFolders.push(...results);
        }
      };
      await Promise.all(Array.from({ length: Math.min(CONCURRENCY, directSubfolderEntries.length) }, worker));
    }

    console.log(`⏱️ [Supply] listSupplyFoldersWithSmartDepth total: ${(performance.now() - t0).toFixed(0)}ms → ${smartFolders.length} folders`);
    return { entries: smartFolders, has_more: false };
  } catch (error) {
    console.error(`Error in listSupplyFoldersWithSmartDepth for "${supplyPath}":`, error);
    throw error;
  }
};

/**
 * Count total subfolders and files in a parent folder (recursive)
 * Used for displaying folder counts like "High Res All (67 folders - 2000 files)"
 */
const countFolderContents = async (folderPath) => {
  try {
    const result = await withRateLimitRetry(
      () =>
        dbx.filesListFolder({
          path: folderPath,
          recursive: true,
          include_media_info: false,
        }),
      "countFolderContents"
    );

    let allEntries = [...result.result.entries];

    // Handle pagination if there are more results
    let cursor = result.result.has_more ? result.result.cursor : null;
    while (cursor) {
      const continueResult = await withRateLimitRetry(
        () => dbx.filesListFolderContinue({ cursor }),
        "countFolderContents"
      );
      allEntries = allEntries.concat(continueResult.result.entries);
      cursor = continueResult.result.has_more
        ? continueResult.result.cursor
        : null;
    }

    // Count folders and files
    const folderCount = allEntries.filter(
      (entry) => entry && entry[".tag"] === "folder"
    ).length;
    const fileCount = allEntries.filter(
      (entry) => entry && entry[".tag"] === "file"
    ).length;

    return { folderCount, fileCount, totalCount: allEntries.length };
  } catch (error) {
    console.error(`Error counting contents of "${folderPath}":`, error);
    return { folderCount: 0, fileCount: 0, totalCount: 0 };
  }
};

/**
 * Get an existing shared link or create a new one.
 * Handles 409 conflicts by retrying the list operation.
 */
const getOrCreateSharedLink = async (path) => {
  console.log(`🔗 getOrCreateSharedLink: Requesting link for "${path}"`);

  try {
    // 1. Check for existing link
    const existingLinkRes = await withRateLimitRetry(
      () => dbx.sharingListSharedLinks({
        path: path,
        direct_only: true,
      }),
      "getOrCreateSharedLink"
    );

    if (
      existingLinkRes &&
      existingLinkRes.result &&
      existingLinkRes.result.links.length > 0
    ) {
      console.log(`✅ getOrCreateSharedLink: Found existing link for "${path}"`);
      return existingLinkRes.result.links[0].url;
    }

    // 2. Create new link
    console.log(`➕ getOrCreateSharedLink: Creating new link for "${path}"`);
    const createLinkRes = await withRateLimitRetry(
      () => dbx.sharingCreateSharedLinkWithSettings({
        path: path,
        settings: {
          requested_visibility: "public",
          audience: "public",
          access: "viewer",
        },
      }),
      "getOrCreateSharedLink"
    );
    return createLinkRes.result.url;

  } catch (error) {
    // 3. Handle 409 Conflict (Link might have been created concurrently)
    if (error.status === 409 || (error.error && error.error.error_summary && error.error.error_summary.includes("shared_link_already_exists"))) {
      console.warn(`⚠️ getOrCreateSharedLink: Conflict (409) for "${path}", retrying list...`);
      try {
        const retryLinkRes = await withRateLimitRetry(
          () => dbx.sharingListSharedLinks({
            path: path,
            direct_only: true,
          }),
          "getOrCreateSharedLink_Retry"
        );

        if (
          retryLinkRes &&
          retryLinkRes.result &&
          retryLinkRes.result.links.length > 0
        ) {
          console.log(`✅ getOrCreateSharedLink: Found link on retry for "${path}"`);
          return retryLinkRes.result.links[0].url;
        }
      } catch (retryError) {
        console.error(`❌ getOrCreateSharedLink: Retry failed for "${path}":`, retryError);
        throw retryError;
      }
    }

    console.error(`❌ getOrCreateSharedLink: Error for "${path}":`, error);
    throw error;
  }
};

export {
  getDropboxFileRequest,
  getDropboxLink,
  getDropboxUrlWithRetry,
  listFolderContents,
  listSubfolders,
  listSupplyFoldersWithSmartDepth,
  countFolderContents,
  scanFolderStructure,
  getThumbnails,
  getThumbnailsWithRateLimit,
  getFullResolutionUrls,
  getFullResImages,
  getAllFiles,
  batchCopyToClientSelects,
  uploadFilesToDropbox,
  uploadFilesToDropboxConcurrent,
  uploadFilesWithFolderStructure,
  uploadFilesWithFolderStructureConcurrent,
  createDropboxFolder,
  loadImagesProgressively,
  checkWebPSupport,
  getOrCreateSharedLink
};
function noop() { }

// Utility: check if browser supports webp, with localStorage persistence
const checkWebPSupport = () => {
  // If cached in localStorage, use that
  const cached = localStorage.getItem("supportsWebP");
  if (cached !== null) {
    return Promise.resolve(cached === "true");
  }

  // Otherwise, run detection once
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const result = img.width > 0 && img.height > 0;
      localStorage.setItem("supportsWebP", result); // save result
      resolve(result);
    };
    img.onerror = () => {
      localStorage.setItem("supportsWebP", false);
      resolve(false);
    };
    img.src =
      "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
  });
};
